import { c as _c } from "react/compiler-runtime";
import { clsx } from "clsx";
import type { ReactNode } from "react";
import { regularButtonCommonClasses, regularButtonVariantClasses } from "@/components/Button/regular-button-class-names";
type FeatureButtonComponentProps = {
  readonly icon: ReactNode;
  readonly label: string;
  readonly title: string;
  readonly url: string;
  readonly variant?: "outline-inverse" | "outline" | "primary" | "secondary";
  readonly position: string;
};
export function ShareLink(t0) {
  const $ = _c(8);
  const {
    icon,
    position,
    label,
    url,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "primary" : t1;
  const t2 = regularButtonVariantClasses[variant];
  let t3;
  if ($[0] !== t2) {
    t3 = clsx(regularButtonCommonClasses, t2, "group flex size-6 items-center justify-center gap-1 rounded-full p-1");
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== icon || $[3] !== label || $[4] !== position || $[5] !== t3 || $[6] !== url) {
    t4 = <a className={t3} data-k5a-pos={position} href={url} rel="noreferrer" target="_blank" title={label}>{icon}</a>;
    $[2] = icon;
    $[3] = label;
    $[4] = position;
    $[5] = t3;
    $[6] = url;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}